import type { CreateDashboardInput } from '@clockwise/clients/dashboards';
import { emptyDefinition } from '@clockwise/semantic-core';
import { resolveDateRange } from '@clockwise/shared/date-range';

/**
 * A blank dashboard, over the current month.
 *
 * The period is stored as the MACRO plus the window it currently resolves to,
 * which is what makes a new dashboard a standing question rather than a
 * snapshot of the month it happened to be created in.
 */
export function emptyDashboard(name = 'Untitled dashboard'): CreateDashboardInput {
  const window = resolveDateRange({ preset: 'current_month' });
  return {
    name,
    definition: emptyDefinition({
      preset: 'current_month',
      // `resolveDateRange` cannot fail for a macro, but the type allows null;
      // the fallback is the same day rather than an empty string, which would
      // not parse as a date.
      from: window?.from ?? today(),
      to: window?.to ?? today(),
    }),
  };
}

const today = () => new Date().toISOString().slice(0, 10);
